import { createContext, useContext } from 'react';

/**
 * @type {React.Context<{
 *  mode: import('utils/types').Mode,
 *  variant: 'default' | 'number',
 *  orientation: import('utils/types').Orientation
 *  nodeGap: import('utils/types').Space,
 *  value: string | null,
 *  lastStepId: string | null,
 *  stepsPositionMap: Record<string, number>
 * }>}
 */
export const StepperContext = createContext();

export function useStepper() {
  const context = useContext(StepperContext);
  if (!context) {
    throw new Error('useStepper must be used within a StepperProvider');
  }
  return context;
}
